import React, { useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { Breadcrumb } from "antd";
import { PROFILE_PATHS } from "@aspen/libs";
import successIcon from "@aspen/assets/images/ic_successfully@2x.png";
import { useRouter } from "next/router";
import type { TKycInfoV2 } from "@adgm/cross-models";
import { WithKYCInfo } from "@aspen/ui";
import { i18nUtil } from "@aspen/libs";

interface IProps {
  kycInfo: TKycInfoV2;
  getKYCInfo: () => void;
}
const Result: React.FC<IProps> = props => {
  const router = useRouter();
  const intl = i18nUtil.t();
  const { kycInfo } = props;

  useEffect(() => {
    props.getKYCInfo();
  }, []);

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>{intl["common.location"]}:</Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link href={PROFILE_PATHS.PROFILE}>{intl["common.profile"]}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{intl["common.KYC"]}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="mt-[24px] text-center bg-[#1f212f] h-[680px]">
        <div className="w-[620px] mx-auto">
          <Image
            unoptimized
            src={successIcon}
            alt="success"
            width={80}
            height={80}
            className="mt-[100px]"
          />
          <p className="mt-[33px] font-[DINPro] font-medium text-2xl">
            {intl["kyc.form.individual.success.title"]}
          </p>
          <p className="mt-[22px] text-[#FFFFFFBF] font-[DINPro] font-medium text-sm">
            {intl["kyc.form.individual.success.content"]}
          </p>
          <div className="flex !justify-center mt-[32px] gap-[20px]">
            <div
              className="flex w-[141px] h-[40px] !justify-center items-center rounded-[2px]  cursor-pointer text-[14px] border-[1px] border-solid  border-[#B8B8B8]"
              onClick={() => {
                router.push({ pathname: PROFILE_PATHS.PROFILE });
              }}>
              {intl["common.Close"]}
            </div>
            <div
              className="flex w-[200px]  md:w-[171px] h-[48px] md:h-[40px] !justify-center items-center rounded-[4px] md:rounded-[2px] bg-[#F17E00] cursor-pointer text-[18px] md:text-[14px]"
              onClick={() => {
                router.push({ pathname: PROFILE_PATHS.PROFILE_KYC_INFORMATION });
              }}>
              {intl["common.ViewDetails"]}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const PageKycResult = WithKYCInfo(Result);
